import React, { Component } from 'react'
import PropTypes from 'prop-types'
import BigTipBox from './BigTipBox'
import SmallTipBox from './SmallTipBox'
import { VARIANTS } from '../../../constants'
import { sendEvent } from '../../utils/googleAnalytics'

class TipBox extends Component {
  handleCLick = () => {
    const { box, googleAnalytics } = this.props
    sendEvent(googleAnalytics, {
      category: 'Article',
      action: 'Tip dne',
      label: box.link
    })
  }
  render () {
    const {
      box,
      variant
    } = this.props

    if (variant === VARIANTS.BIG) {
      return <BigTipBox handleClick={this.handleCLick} box={box}/>
    } else {
      return <SmallTipBox handleCLick={this.handleCLick} box={box}/>
    }
  }
}

TipBox.propTypes = {
  box: PropTypes.object.isRequired
}

export default TipBox
